import React, { useState, useEffect, Fragment, useContext } from 'react';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import SiteInfoQuestions from 'components/sales/formSection/siteInfo/siteInfo';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const PmChecklistQues = ({
  gateInfo = null,
  documentUploadUrl,
  documentUploadUrlPublic,
  match,
  location,
  pmChecklistQues,
  postPmAnswer,
  fetchPmQues,
  history
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [docVal, setDocVal] = useState(null);
  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    if (fetchPmQues !== null)
      (async () => {
        let gateId =
          location?.state?.gateId || queryString.parse(location.search)?.gateId;
        if (match?.params?.id && gateId) {
          setIsLoading(true);
          await fetchPmQues(match?.params?.id, gateId);
          setIsLoading(false);
        }
      })();
  }, [
    fetchPmQues,
    match?.params?.id,
    location?.state?.gateId,
    location.search,
  ]);

  const handleFormVal = (val) => {
    setFormData(val);
  };
  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };

  const handleSubmit = async () => {
    if (formData === null) {
      setIsFiled(true);
      setIsModal(false);
    } else {
      // console.log('formData', formData); return false;
      setIsFiled(true);
      (async () => {
        setIsLoading(true);
        // setFormData({ ...formData, schedule_id: match.params.manageId });
        const res = await postPmAnswer({
          ...formData,
          schedule_id: match.params.manageId,
          docs: docVal
        });
        setIsLoading(false);
        if (res === true) {
          setIsModal(true);
        }
      })();
    }
  };

  return (
    <Layout
      title={localization.pendingTask}
      className={isFiled && 'requiredFileds'}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/view-project-pm-list/${match?.params?.id}/${match?.params?.manageId}`}
    >
      <div>
            <FileUpload
              id="agreementContractUpload"
              accept=".pdf,.png,.jpg"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) => setDocVal(val)}
            >
              <span className="btn btn-transparent">
                {localization.uploadDocs}
              </span>
            </FileUpload>
          </div>
      <SiteInfoQuestions
        className={isFiled && 'requiredFileds'}
        data={pmChecklistQues}
        handleValue={handleFormVal}
        documentUploadUrl={documentUploadUrl}
        documentUploadUrlPublic={documentUploadUrlPublic}
        formData={formData}
        match={match}
        location={location}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={history.goBack}
            className="btn btn-primary mb-4"
          >
            {localization.viewPmList} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default PmChecklistQues;
